// Copyright (c) 2016 Deere & Company

import ProductInformationContainer from './product-information-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.maintenancePlan.claim,
    formValidation: state.claims.maintenancePlan.formValidation,
    goodsInstallationVatOptions: state.claims.goodsInstallationVatOptions,
    isEditable: state.claims.maintenancePlan.isEditable,
    product: state.claims.maintenancePlan.product,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ProductInformationContainer);



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/components/product-information/index.js